import React from "react";

import "./index.css";
import "leaflet/dist/leaflet.css";
import { Map, TileLayer, Marker } from "react-leaflet";

import L from "leaflet";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  popupAnchor: [12, -9],
});
L.Marker.prototype.options.icon = DefaultIcon;

export class LeafMap extends React.Component {
  renderMarkers = () =>
    this.props.handelaars.map((h, i) => {
      return (
        <Marker
          onclick={() => this.props.setModalHandelaar(i)}
          key={i}
          position={[h.lat, h.long]}
        ></Marker>
      );
    });

  render = () => {
    const position = [this.props.lat, this.props.lng];

    return (
      <div id="container">
        <Map
          center={position}
          zoom={this.props.zoom}
          minZoom={this.props.minZoom}
        >
          <TileLayer
            attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OSM contributors</a>'
            url="https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
          />

          {this.renderMarkers(this.props.handelaars)}
        </Map>
      </div>
    );
  };
}
